import axiosInterceptor from "../../utils/axiosInterseptor";

export const suspendedUserRoute = (queryParam) =>
  axiosInterceptor.get(`/admin/suspenedUsersOnDashboard${queryParam}`);
export const blockedUserRoute = (queryParam) =>
  axiosInterceptor.get(`/admin/getBlockUserOnDashboard${queryParam}`);
